import { Invoice } from "../../../buy/services/invoice.model";

export default class NoAuthBillInfoAddController {
  private invoice: Invoice;
  private msisdn;

  constructor() { }

  public $onInit() { }
}



// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info-add/bill-info-add.controller.ts